import { InfoCardProps } from './InfoCardProps';
import S from './InfoCardStyles';

type Props = {
  data: InfoCardProps,
  type?: 'single' | 'double' | 'triple' | 'quad',
};

function InfoCard({ data, type }: Props): JSX.Element {
  return (
    <S.Wrapper $type={type}>
      <div className="dot" style={{ background: data.color }} />
      <div className="count">{typeof (data.count) !== 'undefined' ? data.count : 'N/A'}</div>
      <div className="label">{data.label || 'N/A'}</div>
    </S.Wrapper>
  );
}

export default InfoCard;
